import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface ProjectPageIndexDTO {
  items: number;
}

export class ProjectPageIndex {
  readonly isProjectPageIndexProjectPageIndex: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 0,
    }
  }

  constructor(
  items: number
  ) {
    ProjectPageIndex.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: ProjectPageIndexDTO): ProjectPageIndex {
    const items = getInt32(dto, "items", InvalidProjectPageIndexItemsError);
    return new ProjectPageIndex(
      items
    );
  }

  toDTO(): ProjectPageIndexDTO {
    const dto: ProjectPageIndexDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 0) {
      throw new InvalidProjectPageIndexItemsMinValueError(
        0,
        `Attribute items has value ${items}. Min value is 0.`
      );
    }
  }
  
}

ProjectPageIndex.prototype.toString = function toString(): string {
  return `ProjectPageIndex(items='${this.items}')`;
};

export class InvalidProjectPageIndexError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectPageIndexError";
  }
}
export class InvalidProjectPageIndexItemsError extends InvalidProjectPageIndexError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectPageIndexItemsError";
  }
}

export class InvalidProjectPageIndexItemsMinValueError extends InvalidProjectPageIndexItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectPageIndexItemsMinValueError";
  }
}
